<template>
<div>
  <el-form ref="form" label-width="80px" style="padding: 10px;margin: 0px auto;width: 100%;min-width: 1000px;">
    <el-row style="margin-bottom: 10px; width:1500px">
      <el-col :span="3">
        <el-date-picker style="width: 155px" v-model="report.date" format="YYYY - MM - DD " value-format="YYYY-MM-DD" placeholder="选择日期"/>
      </el-col>
      <el-col :span="1">
        <el-button type="primary" @click="searchData" :loading="searchLoading">查询</el-button>
      </el-col>
      <el-col :span="1">
        <el-button type="primary" @click="exportReport" :loading="exportLoading" style="margin-left: 20px">导出</el-button>
      </el-col>
    </el-row>
  </el-form>

  <el-table :data="tableData" v-loading="searchLoading" border style="width: 100%" :header-cell-style="{textAlign: 'center'}" max-height="600">
    <el-table-column v-for="item in tableColumn" :key="item.column" :prop="item.prop" :label="item.column" :width="item.width" :align="'center'"  :show-overflow-tooltip="true" :min-width="item.min_width">
    </el-table-column>
  </el-table>
</div>
</template>

<script>
export default {
  name: "BusReportExport",
  props: {
    componentParam: {
      type: String,
      required: true
    },
  },
  data(){
    return{
      tableData:[],
      tableColumn:[],
      boli_columns:[
          {prop:'create_time',column:"检查日期",width:140},
          {prop:'wujian_name',column:"物件名",width:140},
          {prop:'supplier_name',column:"供应商",width:200},
          {prop:'glass_no',column:"玻璃编号",width:140},
        {prop:'inventory_code',column:"存货编码",width:140},
        {prop:'glass_bad_no',column:"不良编号",width:140},
          {prop:'check_num',column:"检查数量",width:140},
          {prop:'bad_blame',column:"不良他责",width:140},
          {prop:'bad_content',column:"他责内容",min_width:160},
          {prop:'bad_blame_self',column:"不良自责",width:140},
          {prop:'bad_content_self',column:"自责内容",min_width:160},
          {prop:'remark',column:"备注",width:140}
        ],
      xingcai_columns:[
            {prop:'create_time',column:"检查日期",width:140},
            {prop:'wujian_name',column:"物件名",width:140},
            {prop:'in_date',column:"入货日期",width:200},
            {prop:'purchase_no',column:"订单号",width:140},
        {prop:'in_count',column:"入库数量",width:140},
        {prop:'inventory_code',column:"存货编码",width:140},
            {prop:'xingcai_no',column:"型番",width:140},
        {prop:'color',column:"颜色",width:60},
        {prop:'caizhi',column:"材质",width:140},
            {prop:'specs',column:"规格",width:140},
            {prop:'checked',column:"已检查",width:140},
            {prop:'bad_blame',column:"不良他责",width:140},
        {prop:'bad_detail',column:"他责内容",width:140},
            {prop:'bad_blame_self',column:"不良自责",width:140},
        {prop:'bad_detail_self',column:"自责内容",width:140},
            {prop:'single_weight',column:"单重KG/M",width:140},
            {prop:'bad_blame_KG',column:"不良他责KG",width:140},
            {prop:'bad_blame_self_KG',column:"不良自责KG",width:140},
            {prop:'total_weight',column:"总重",width:140},
            {prop:'yield',column:"良品率/%",width:140},
            {prop:'remark',column:"备注",width:140},
        {prop:'supplier_name',column:"供应商",width:250}
          ],
      wuJianIdList: [],
      report:{
        wujian_id:'',
        model_id:'',
        date:''
      },
      searchLoading:false,
      exportLoading:false
    }
  },
  methods:{
    searchData(){
      this.getDailyData()
    },

    /*async getWuJianIds() {
      let {data: res} = await this.$axios.get('bus/wujian/getAllWuJianId');
      if (res.code !== 0) {
        this.$message.error('获取物件ID失败')
        return;
      }
      this.wuJianIdList = res.data;
    },*/

    async exportReport(){
      this.exportLoading = true
      this.report.columns = this.tableColumn
      let {data: res} = await this.$axios.post('bus/exportReport/doExportReport',this.report);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.exportLoading = false
      if (res.data.url) {
        const link = document.createElement('a');
        link.href = res.data.url;
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      }
    },

    async getDailyData(){
      this.searchLoading = true
      let {data: res} = await this.$axios.post('bus/exportReport/searchData',this.report);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.tableData = res.data
      }
      this.searchLoading = false
    }
  },
  created() {
    if (this.componentParam === 'bus_shouru_boli_daily_report'){
      this.tableColumn = this.boli_columns
      this.report.name = '受入玻璃每日检查统计'
    }
    if (this.componentParam === 'bus_xingcai_daily_report'){
      this.tableColumn = this.xingcai_columns
      this.report.name = '型材每日检查统计'
    }
    /*this.getWuJianIds()*/
  }
}
</script>

<style scoped>

</style>